import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { TextOnlyLogo, MenuIcon } from './Logo';
import { ILivHeader } from './header.definition';
import LogudKnap from './LogudKnap';

const MotionMenuIcon = motion(MenuIcon);

const Header = ({ title, links, url = '/', visLogud = false }: ILivHeader) => {
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const toggleNav = () => setIsOpen(!isOpen);
	const hasLinks = links && links.length > 0;

	useEffect(() => {
		document.documentElement.style.paddingTop = '80px';
		return () => {
			document.documentElement.style.paddingTop = '0px';
		};
	}, []);


	const renderDrawer = () => (
		hasLinks && (
			<motion.div
				style={ { height: 0 } }
				animate={ { height: isOpen ? 'auto' : 0 } }
				className="header__drawer"
				transition={ { ease: 'easeOut' } }
			>
				<div className="f-grid-0">
					<div className="col-lg-6 col-lg-shift-3 col-md-shift-1">
						<nav className="header__nav">
							<ul>
								{ links.map((link) => (
									<li key={ link.title }>
										<a
											href={ link.url }
											className="header__link text-white text-xl responsive"
											target={ link.target || '_self' }
											onClick={ toggleNav }
										>
											{ link.title }
										</a>
									</li>
								)) }
							</ul>
						</nav>
					</div>
				</div>
			</motion.div>
		)
	);

	const renderHeader = () => (
		<section className="f-grid header__bar ">
			<div className="col-lg-2">
				<div style={ { paddingTop: 8 } }>
					<a href={ url } title={ 'PKA' } onClick={ toggleNav }>
						<div style={ { width: '50px' } }>
							<TextOnlyLogo />
						</div>
					</a>
				</div>
			</div>
			<div className="col-lg-8">
				<div style={ { paddingTop: 8 } } className="text-center align-items-center d-flex justify-content-center">
					<span className="text-xs color-secondary">
						{ title ? title : '' }
					</span>{ ' ' }
				</div>
			</div>
			<div className="col-lg-2">
				<div style={ { minWidth: '100%', justifyContent: 'flex-end' } } className="d-flex">
					{ visLogud && (
						<LogudKnap />
					) }
					{ hasLinks && (
						<button onClick={ toggleNav } className="button button--reset" style={ { lineHeight: 0, marginLeft: 8 } }>
							<MotionMenuIcon
								animate={ {
									rotate: isOpen ? 45 : 0,
									scale: isOpen ? 1.5 : 1
								} }
								transition={ { ease: 'easeOut' } }
								initial={ false }
							/>
						</button>
					) }
				</div>
			</div>
		</section>
	);

	return (
		<div className="header">
			{ renderDrawer() }
			<div>
				{ renderHeader() }
			</div>
		</div>
	);
};

export default Header;
